module.exports = __webpack_public_path__ + "img/banner.8ab756db.png";